import { Component, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { OutputService } from '../../services/output.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  templateUrl: './printing-output-page.html',
  styleUrls: ['./printing-output-page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class PrintingOutputPageComponent {

  output = '<h2 class="loading">...LOADING...</h2>';
  letter;

  constructor(
    private outputService:OutputService,
    private route:ActivatedRoute,
  ) {
  }


  ngOnInit() {

    this.route.params
      .take(1)
      .subscribe(params => {

        // get letter
        if (! Number(params.letter)) return;
        this.letter = Math.floor(Number(params.letter));
        if (this.letter < 1  ||  this.letter > 22) {
          this.output = 'Invalid letter';
          return;
        }


        Promise.resolve()
          .then(() => this.outputService.create({
            mode: 'printing',
            letter: this.letter,
          }))
          .then(result => {

            this.output = result.output;

            setTimeout(() => {
              this.printPage();
            }, 250);

          });

      });


  }



  printPage() {
    window.print();
  }


  getHebrewLetter(letter) {
    const letters = {
      1: 'א',
      2: 'ב',
      3: 'ג',
      4: 'ד',
      5: 'ה',
      6: 'ו',
      7: 'ז',
      8: 'ח',
      9: 'ט',
      10: 'י',
      11: 'כ',
      12: 'ל',
      13: 'מ',
      14: 'נ',
      15: 'ס',
      16: 'ע',
      17: 'פ',
      18: 'צ',
      19: 'ק',
      20: 'ר',
      21: 'ש',
      22: 'ת',
    };

    return letters[letter];
  }

}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/printing-output-page/printing-output-page.ts